export default async function msFetch(url, params) {
  let fetchParams = params;
  if (!fetchParams) {
    fetchParams = { headers: {} };
  }

  const res = await fetch(url, fetchParams);

  if (res.status === 401) {
    const refreshRes = await fetch('/gap/refresh');

    if (refreshRes.status !== 200) {
      window.location = `${window.location.origin}/gap/redirect?redirect-uri=/`;
      return null;
    }

    const secondAttemptRes = await fetch(url, fetchParams);
    if (secondAttemptRes.status === 401) {
      throw new Error(`fetch ${url} returned 401 right after refresh`);
    }

    return secondAttemptRes;
  }

  return res;
}
